<ng-container bbTransactionSigningActionPendingCustomizable [bbHostRef]="hostRef"></ng-container>

<ng-template bbTransactionSigningActionPendingCustomizable let-hostRef>
  <bb-loading-indicator-ui
    data-role="ts-action-pending"
    loaderSize="lg"
    i18n-text="Transaction signing action pending text@@bb-transaction-signing-action-pending.text"
    text="Performing action...">
  </bb-loading-indicator-ui>
</ng-template>